import React from 'react'
import {useLocation} from 'react-router-dom'
import '../styles/acknowledgementStyles.css'
import {
  BlueGradientBackground,
  HeaderDivider,
} from '../components/payment-information-components/cc-desktop'
// import {useSelector} from 'react-redux'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import keapLogo from '../assets/proposal-tool/keap-white.png'
import logo from '../assets/thryv-logo-white-letters.svg'
import thanksForYourPurchase from '../assets/payment-completed-image.png'
import {ReactComponent as CalendarIcon} from '../assets/proposal-tool/calendar-day.svg'
dayjs.extend(utc)
dayjs.extend(advancedFormat)
dayjs.extend(timezone)

export function getFormattedDateTime(dateStr) {
  if (dateStr?.timezone && dateStr?.timezone?.length > 0) {
    if (dateStr?.timezone?.includes('Eastern Daylight Time')) {
      return (
        dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'EDT'
      )
    } else {
      return dayjs(dateStr?.start_time)
        .tz(dateStr?.timezone)
        .format('MMMM D[,] YYYY [@] h:mm A z')
    }
  } else {
    return (
      dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'CDT'
    )
  }
}

export const SuccessAcknowledge = () => {
  let data = useLocation()
  const {
    email,
    onboardingCalls,
    creativeCalls,
    thryvSuccessServicesCalls,
    isSEOIncluded,
    isAnnual,
  } = data?.state || {}
  console.log('data - success acknowledge', data)
  console.log('email - success acknowledge', email)
  console.log('onboardingCalls - success acknowledge', onboardingCalls)
  console.log('creativeCalls - success acknowledge', creativeCalls)
  console.log(
    'thryvSuccessServicesCalls - success acknowledge',
    thryvSuccessServicesCalls,
  )
  console.log('isSEOIncluded - success acknowledge', isSEOIncluded)

  //   const {isMobileViewEnable} = useSelector(state => state?.screenView)
  const Appointment = ({appointment, title}) => (
    <div className="appointment-card d-flex flex-row w-100">
      <p className="m-0 appointment-title" color="#231F20">
        {title}
      </p>
      <p className="m-0 appointment-time">
        {': '}
        <span className="appointment-datetime">
          {getFormattedDateTime(appointment)}
        </span>
      </p>
    </div>
  )
  return (
    <>
      <BlueGradientBackground showLogo={true} />
      <section className="acknowledgement-container">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 0,
            flexShrink: 0,
          }}
        >
          <img src={logo} alt="Thryv Logo" className="header-logo" />
          <HeaderDivider />
          <img src={keapLogo} alt="Keap Logo" className="header-logo" />
        </div>
        <div className={`acknowledgement-card`}>
          <div className="acknowledgement-image-wrapper">
            <img src={thanksForYourPurchase} alt="Thanks for the purchase" />
          </div>
          <div className="acknowledgement-content">
            <p className="acknowledgement-title">Thank You for Your Payment!</p>
            <p className="acknowledgement-subtitle">
              Your payment information has been successfully updated. We will
              use this information to bill your Thryv subscriptions{' '}
              {isAnnual ? 'each year' : 'each month'}. You can update your
              billing information through the My Account page.
            </p>
            <div className="next-steps-list">
              <p className="next-steps-list-title">Next steps from Thryv:</p>
              <ul>
                <li>A dedicated Thryv Success Manager will reach out</li>
                <li>Mobile app access will be enabled</li>
                <li>Online listings will be updated and secured</li>
                <li>CRM configuration will begin</li>
              </ul>
            </div>
            <p className="next-steps-list-subtitle">
              We appreciate your business and look forward to helping you grow!
            </p>
            {(onboardingCalls?.length > 0 ||
              creativeCalls?.length > 0 ||
              thryvSuccessServicesCalls?.length > 0) && (
              <>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    columnGap: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      columnGap: '12px',
                      alignItems: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <CalendarIcon height="20px" width="22px" color="#FF5000" />
                    <p
                      style={{
                        fontWeight: 600,
                        fontSize: '16px',
                      }}
                      className="m-0"
                    >
                      Your Upcoming Appointments
                    </p>
                  </div>
                  {onboardingCalls?.map(item => {
                    let appointmentTitle = 'Thryv Kickoff Call'
                    return (
                      <Appointment
                        title={appointmentTitle}
                        key={item.type}
                        appointment={item}
                      />
                    )
                  })}
                  {creativeCalls?.map(item => {
                    let appointmentTitle = 'Website Design Call'
                    return (
                      <Appointment
                        title={appointmentTitle}
                        key={item.type}
                        appointment={item}
                      />
                    )
                  })}
                  {thryvSuccessServicesCalls?.map(item => {
                    let appointmentTitle = 'Thryv Success Service Call'
                    return (
                      <Appointment
                        title={appointmentTitle}
                        key={item.type}
                        appointment={item}
                      />
                    )
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
